import React from "react";
import { ReactComponent as DarkLogo } from "_assets/images/logos/empire-logo-dark.svg";
import { ReactComponent as LightLogo } from "_assets/images/logos/empire-logo-light.svg";
import { ReactComponent as ShortLogo } from "_assets/images/logos/empire-logo-short.svg";

import { useMainStore } from "_hooks";
import { ThemeModeEnum } from "_constants";
import PropTypes from "prop-types";
import { StyledAppLogoShortWrapper } from "./index.styled";

const AppLogo = (props) => {
  const { height, width, onClick, short = false } = props;
  const {
    main: { themeMode },
  } = useMainStore();
  if (short)
    return (
      <StyledAppLogoShortWrapper height={height} theme_mode={themeMode}>
        <ShortLogo height={height} width={width} onClick={onClick} />
      </StyledAppLogoShortWrapper>
    );
  if (themeMode === ThemeModeEnum.LIGHT)
    return <LightLogo height={height} width={width} onClick={onClick} />;
  return <DarkLogo height={height} width={width} onClick={onClick} />;
};

AppLogo.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  short: PropTypes.bool,
};

export default AppLogo;
